import {inject, Injectable} from "@angular/core";
import {AUX_ID_PREFIX} from "@core/consts/map.constants";
import {v4 as uuidv4} from 'uuid';
import {DatacenterV2} from "@core/model/datacenter-v2";
import {Observable} from "rxjs";
import {environment} from "@environment/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({providedIn: 'root'})
export class MapService {
  http: HttpClient = inject(HttpClient);

  constructor() {

  }

  public buildAuxId(): string {
    return `${AUX_ID_PREFIX}${uuidv4()}`;
  }

  public buildInitialDatacenter(): DatacenterV2 {
    return {
      id: null,
      auxId: this.buildAuxId()
    } as DatacenterV2;
  }

  //API calls
  public getUserMap(mapId: string, full: boolean): Observable<any> {
    //ToDo modify this URI
    return this.http.get(`${environment.apiUrl}/maps/1234/${mapId}?full=${full}`, {responseType: 'json'});
  }
}
